var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Decimal, Trove, _normalizeTroveAdjustment, _normalizeTroveCreation, } from '@sovryn-zero/lib-base';
import { SupportedTokens } from '@sovryn/contracts';
import { decimalic } from '../../../../utils/math';
import { getLiquityBaseParams } from './';
import { getZeroProvider } from './zero-provider';
export const openTrove = (token, params, maxBorrowingRate) => __awaiter(void 0, void 0, void 0, function* () {
    const normalized = _normalizeTroveCreation(params);
    const { depositCollateral, borrowZUSD } = normalized;
    const { ethers } = yield getZeroProvider();
    const fees = borrowZUSD && (yield getLiquityBaseParams());
    const newTrove = Trove.create(normalized, fees === null || fees === void 0 ? void 0 : fees.minBorrowingFeeRate.toString());
    const value = depositCollateral !== null && depositCollateral !== void 0 ? depositCollateral : Decimal.ZERO;
    const hints = yield ethers.populate.findHints(newTrove);
    const borrowingRate = maxBorrowingRate
        ? decimalic(maxBorrowingRate).div(100).toHexString()
        : fees === null || fees === void 0 ? void 0 : fees.maxBorrowingFeeRate.toHexString();
    return {
        value: value.hex,
        fn: token === SupportedTokens.dllr ? 'openNueTrove' : 'openTrove',
        args: [borrowingRate, borrowZUSD.hex, ...hints],
    };
});
export const adjustTrove = (token, address, params, maxBorrowingRate) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const normalized = _normalizeTroveAdjustment(params);
    const { depositCollateral, withdrawCollateral, borrowZUSD, repayZUSD } = normalized;
    const { ethers } = yield getZeroProvider();
    const [trove, fees] = yield Promise.all([
        ethers.getTrove(address),
        borrowZUSD && getLiquityBaseParams(),
    ]);
    const finalTrove = trove.adjust(normalized, fees === null || fees === void 0 ? void 0 : fees.minBorrowingFeeRate.toString());
    const value = depositCollateral !== null && depositCollateral !== void 0 ? depositCollateral : Decimal.ZERO;
    const hints = yield ethers.populate.findHints(finalTrove);
    const borrowingRate = maxBorrowingRate
        ? decimalic(maxBorrowingRate).div(100).toHexString()
        : (_b = (_a = fees === null || fees === void 0 ? void 0 : fees.maxBorrowingFeeRate) === null || _a === void 0 ? void 0 : _a.toHexString()) !== null && _b !== void 0 ? _b : Decimal.ZERO.hex;
    return {
        value: value.hex,
        fn: token === SupportedTokens.dllr ? 'adjustNueTrove' : 'adjustTrove',
        args: [
            borrowingRate,
            (withdrawCollateral !== null && withdrawCollateral !== void 0 ? withdrawCollateral : Decimal.ZERO).hex,
            ((_c = borrowZUSD !== null && borrowZUSD !== void 0 ? borrowZUSD : repayZUSD) !== null && _c !== void 0 ? _c : Decimal.ZERO).hex,
            !!borrowZUSD,
            ...hints,
        ],
    };
});
